export default __webpack_public_path__ + "static/media/background.094ea109.jpg";